module.exports = __webpack_public_path__ + "img/num_48.8e6f3d70.png";